import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  split,
} from '@apollo/client'
import Auth from '@aws-amplify/auth'
import { setContext } from '@apollo/client/link/context'
import { WebSocketLink } from '@apollo/client/link/ws'
import { getMainDefinition } from '@apollo/client/utilities'
import { isLocal } from '../../utils/env.utils'

const getAccessToken = async (): Promise<string | null> => {
  try {
    const user = await Auth.currentSession()
    return user.getIdToken().getJwtToken()
  } catch (error) {
    console.error(error)
    if ('NotAuthorizedException' === error?.code) {
      console.error(error)
    }
    return null
  }
}

const httpLink = createHttpLink({
  uri: `${isLocal() ? 'http': 'https'}://${process.env.NEXT_PUBLIC_SLOWTALK_API}/graphql`,
})

const getAuthHeaders = async () => {
  const token = await getAccessToken()
  return { Authorization: `Bearer ${token}` }
}
const wsLink = process.browser
  ? new WebSocketLink({
      uri: `wss://${process.env.NEXT_PUBLIC_SLOWTALK_API}/graphql`,
      options: {
        reconnect: true,
        lazy: true,
        inactivityTimeout: 30000,
        connectionParams: async () => {
          return { headers: await getAuthHeaders() }
        },
      },
    })
  : null

const authLink = setContext(async (_, { headers }) => {
  const token = await getAccessToken()
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`,
    },
  }
})

const link = process.browser
  ? split(
      // split based on operation type
      ({ query }) => {
        const definition = getMainDefinition(query)
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        )
      },
      wsLink,
      authLink.concat(httpLink)
    )
  : authLink.concat(httpLink)

const client = new ApolloClient({
  link: link,
  cache: new InMemoryCache(),
})

export default client
